import React, { useCallback, useState, useEffect } from 'react';
import { Markup } from 'interweave';
import { Button, Modal } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../../../i18n/hooks';

import {
  useUpdateUserMutation,
  useGetUserQuery,
  User
} from '../../../app/services/userApi';

import termsConditions from './termsConditions.json';
import BLSpinner from '../../../assets/animations/BLSpinner/BLSpinner';

const TermsConditions = () => {
  const { t: _ } = useTranslation();
  const location = useLocation();
  const locale = useLocale();

  const [show, setShow] = useState<boolean>(false);
  const { data: User } = useGetUserQuery();
  const [updateUser, { isUninitialized, isLoading: updatingUser }] =
    useUpdateUserMutation();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleAccept = useCallback(() => {
    const updatedUser = {
      ...User,
      termsConditions: termsConditions['published-date']
    };

    updateUser({
      user: updatedUser as User
    });
  }, [updateUser, User]);

  useEffect(() => {
    if (User) {
      if (User?.termsConditions !== termsConditions['published-date']) {
        handleShow();
      } else {
        handleClose();
      }
    }
  }, [User]);

  return (
    <Modal show={show} className="terms-conditions-modal" size="lg">
      <Modal.Header>
        <Modal.Title>{_('Terms and Conditions')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="terms-conditions">
          <Markup
            tagName="div"
            content={termsConditions['terms-conditions'][locale]}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Link to="/auth/logout" state={{ from: location }}>
          <Button variant="light" onClick={handleClose}>
            {_('Decline')}
          </Button>
        </Link>

        <Button variant="editing" onClick={handleAccept}>
          {isUninitialized && !updatingUser ? _('Accept') : <BLSpinner />}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsConditions;
